import React from 'react'
import { FormattedMessage } from 'react-intl'

export default class PasswordValidator {
  constructor({ value }) {
    this.lengthh = /^.{8,}$/g
    this.uppercases = /([A-Z]).?/g
    this.specialCharacters = /[^\w\s]/gi
    this.errorMessage = <FormattedMessage id="invalid_password" />
    this.value = value
  }

  validate() {
    if (!this.lengthh.test(this.value)) {
      return <FormattedMessage id="invalid_password_length" />
    }

    if (!this.uppercases.test(this.value)) {
      return <FormattedMessage id="invalid_password_capital_chars" />
    }

    if (!this.specialCharacters.test(this.value)) {
      return <FormattedMessage id="invalid_password_special_chars" />
    }

    return null
  }
}
